// extracted by mini-css-extract-plugin
export var checkbox = "_3i-0";
export var circle = "_3i-3";
export var horizontalContainer = "_3i-7";
export var sm = "_3i-5";
export var switch0 = "_3i-2";
export var switchDisabled = "_3i-8";
export var switchEnabled = "_3i-1";
export var textSwitchContainer = "_3i-9";
export var textSwitchOption = "_3i-a";
export var textSwitchOptionSelected = "_3i-b";
export var verticalContainer = "_3i-6";
export var xs = "_3i-4";